// import React from "react";

// const UserInfo = ({ userName }) => (
//   <div>
//     <h2 className="text-sm xl:text-lg font-alexandria font-normal text-header-text whitespace-nowrap ">
//       {userName || "Unknown User"}
//     </h2>
//   </div>
// );

// export default UserInfo;
import React, { useEffect, useState } from "react";

const UserInfo = ({ userName }) => {
  const [displayName, setDisplayName] = useState(userName || "Unknown User");

  useEffect(() => {
    const updateName = () => {
      if (window.innerWidth < 900 && userName) {
        // Take only the first part before space
        setDisplayName(userName.split(" ")[0]);
      } else {
        setDisplayName(userName || "Unknown User");
      }
    };

    updateName(); // run on mount
    window.addEventListener("resize", updateName);

    return () => {
      window.removeEventListener("resize", updateName);
    };
  }, [userName]);

  return (
    <div>
      <h2 className="text-sm xl:text-lg font-alexandria font-normal text-header-text whitespace-nowrap">
        {displayName}
      </h2>
    </div>
  );
};

export default UserInfo;
